import { Link } from "react-router-dom"

const EditLink = ({ to, label }) => {
  return (
    <Link to={to} className="flex items-center justify-center border-b border-b-[#EBECF1] p-2">
      {label}
    </Link>
  )
}

export default EditLink
